<nz-spin [nzSpinning]="loading">
    <app-st
        #st
        [columns]="columns"
        [data]="data"
        [loading]="loading"
        [page]="{ show: true }"
        [templates]="{ action: action }"
        [scroll]="scroll"
        [ps]="size"
        [pi]="page + 1"
        [total]="total"
        (changes)="handleChange($event)"
        size="small"
    >
        <ng-template #action let-row>
            <button
                nz-button
                nzSize="small"
                (click)="handleDetail(row)"
            >
                Detail
            </button>
        </ng-template>
    </app-st>
</nz-spin>

<app-application-detail #applicationDetail (success)="fetchData()"></app-application-detail>
